import { create } from 'zustand';

export const useGlobalLoading = create<{
  // loading 状态
  globalLoading: boolean;
  setGlobalLoading: (v: boolean) => void;
}>((set) => ({
  globalLoading: false,

  setGlobalLoading: (v: boolean) => {
    set((state) => ({ ...state, globalLoading: v }));
  },
}));
